import { jsx as r } from "react/jsx-runtime";
import a from "../../utils/classNames.js";
const u = (e) => {
  const { isFilterActive: s, filterValue: t, onChange: i } = e, l = a(
    "select-filter-input",
    (s || t) && "select-filter-input-active"
  );
  return /* @__PURE__ */ r("input", { type: "text", className: l, autoFocus: !0, onChange: i, value: t });
};
export {
  u as default
};
//# sourceMappingURL=SelectFilter.js.map
